import { useEffect, useState } from 'react';
import { getRouteIdFromPathname, RouteId } from '@trello/routes';

// This hook relies on @trello/history-events to polyfill the pushstate event.
export function useCurrentRouteId(): RouteId | undefined {
  const [currentRouteId, setCurrentRouteId] = useState<RouteId | undefined>(
    getRouteIdFromPathname(window.location.pathname),
  );

  const handleHistoryEvent = () => {
    setCurrentRouteId(getRouteIdFromPathname(window.location.pathname));
  };

  useEffect(() => {
    window.addEventListener('pushstate', handleHistoryEvent);
    window.addEventListener('popstate', handleHistoryEvent);
    window.addEventListener('replacestate', handleHistoryEvent);

    return () => {
      window.removeEventListener('pushstate', handleHistoryEvent);
      window.removeEventListener('popstate', handleHistoryEvent);
      window.removeEventListener('replacestate', handleHistoryEvent);
    };
  }, []);

  return currentRouteId;
}
